<template>
  <div class="home xlbox" :style="{ height: pageHeight + 'px' }">
    <van-nav-bar
      fixed
      title="线路联系人"
      left-text=""
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="tj" ref="articleRef">
      <van-pull-refresh  v-model="isLoading" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        :offset="10"
        :immediate-check='false'
      >
      <van-empty description="没有数据啦~" v-show="nodataShow"/>
          <!-- <p>刷新次数: {{ count }}</p> -->
          <ul>
            <li class="item xltj"  v-for="(item,index) in Contactlist" :key="index">
              <van-row type="flex"  align="center">
                <van-col  span="4" >
                  <van-image
                    round
                    width="50px"
                    height="50px"
                    :src="imgSrc"
                  />
                </van-col>
                <van-col span="10">
                  <p class="user">
                    <span>{{item.cpname}}</span>
                  </p>
                  <van-button color="#0B7DEC" size="mini" round type="info">系统维护员</van-button>
                </van-col>
                <van-col  justify="end" ><span class="tel">手机号：{{item.phoneNum}}</span></van-col>
              </van-row>
            </li>
          </ul>
      </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Col, Row, Button, NavBar, List, PullRefresh, Icon, Image as VanImage, Empty } from 'vant'

// import axios from 'axios' // 引入axios进行前后端交互
Vue.use(Col, Row, Button, NavBar, List, PullRefresh, Icon, VanImage, Empty)

export default {
  name: 'mlineContactPage',
  components: {
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Icon.name]: Icon,
    [VanImage.name]: VanImage,
    [Empty.name]: Empty

  },
  data () {
    return {
      nodataShow: false,
      count: 0,
      isLoading: false,
      Contactlist: [],
      loading: false,
      finished: false,
      pageHeight: window.innerHeight,
      imgSrc: require('../assets/tx@3x.png'),
      currentPage5: 1, // 当前页
      pagesize: 15, // 每页显示条数
      total: '', // 总条数
      totalPage: '', // 总页数
      // type: '', // 1高跳 2低跳
      offset: 50, // 滚动条与底部距离小于 offset 时触发load事件
      scrollTop: 0 // 在data属性中记录滚动的距离
    }
  },
  created () {
    this.mlineId = this.$route.query.mlineId// 传过来的线路id
    this.currentPage5 = parseInt(localStorage.getItem('currentPage5') || 1)
    // this.getMlineContact()// 线路联系人
  },
  activated () {
    // console.log('activated' + this.scrollTop)
    // console.log(this.scrollTop)
    this.$refs.articleRef.scrollTop = this.scrollTop
  },
  mounted () {
    this.onRefresh()
    let article = this.$refs.articleRef // 获取到根节点
    // 绑定onscroll事件，只要滚动鼠标就会触发该事件，记录滚动的值
    article.addEventListener('scroll', this.pageScroll, true)
  },
  methods: {
    onClickLeft () {
      // window.history.back()
      this.$router.go(-1)// 返回上一页面
    },
    pageScroll () {
      // console.log(this.$refs.articleRef.scrollTop) // 有用就怪了
      this.scrollTop = this.$refs.articleRef.scrollTop
    },
    onRefresh () {
      this.currentPage5 = 1
      this.Contactlist = []
      this.finished = false

      this.getMlineContact()
    },
    getMlineContact () {
      localStorage.setItem('currentPage5', this.currentPage5)// 存储当前页
      this.util.post('/getMlineContact', {
        mlineId: this.$route.query.mlineId,
        currentPage: this.currentPage5, // 当前页
        pagesize: this.pagesize// 每页显示条数
      }).then(({ data }) => {
        if (data.code === 200) {
          this.total = data.data.data.total
          this.totalPage = data.data.data.totalPage

          let infolist = data.data.data.items
          if (infolist.length > 0) {
            this.nodataShow = false
          }

          // 数据全部加载完成
          if (infolist) {
            this.Contactlist = this.Contactlist.concat(infolist)
            this.$nextTick(() => {
              this.loading = false// 取消正在加载状态
              this.isLoading = false
              // 不限制的concat， 人家刷新了，还在保留着以前的数据啊？
              if (this.currentPage5 < this.totalPage) { // 判断接口返回数据量小于请求数据量，则表示此为最后一页
                this.finished = false
              } else {
                this.finished = true
                if (this.Contactlist.length === 0) {
                  this.nodataShow = true
                  this.finishText = ''
                } else {
                  this.nodataShow = false
                  this.finishText = '没有更多了'
                }
              }
            })
          } else {
            this.loading = false// 取消正在加载状态
            this.isLoading = false
            this.finished = true
          }
        } else {
          this.loading = false
          this.isLoading = false
          this.currentPage5 -= 1
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
    // 上拉时执行此函数
    onLoad () {
      if (!this.isLoading) {
        this.currentPage5 += 1
        this.getMlineContact()
      }
    }

  },
  computed: {

  }

}
</script>

<style scoped lang="less">
/deep/.van-nav-bar__content {
  height: 46px;
  background-color: #0b7dec;
}
/deep/.van-nav-bar__title {
  font-size: 17px;
  font-weight: bold;
  color: #fff;
}
/deep/.van-nav-bar .van-icon {
  font-size: 17px;
  color: #fff;
}
.home{
  padding-top: 46px;
}
.item .van-row{
  padding: 5px 0;
}
.van-button--round{
  font-size: 12px;
}
</style>
